<template>
  <div class="et-banner">
    <div class="title">
      <div class="name">参赛代表队</div>
      <div class="total">共计{{ bannerList.length }}支参赛队伍</div>
    </div>
    <div v-if="!hidden">
      <div class="banner-list" v-if="bannerList.length > 0">
        <a-icon type="left" class="arr-left"  :style="{ fontSize: '24px', color: '#999999' }" @click="arrleft"/>
        <a-icon type="right" class="arr-right"  :style="{ fontSize: '24px', color: '#999999' }" @click="arrright"/>
        <div class="banner-item">
          <div class="banner-full" :style="moveStyle">
            <div class="banner-box" v-for="(item,index) in bannerList" :key="index" @click="showPlayer(item)">
              <img :src="item.head" alt="">
              <div class="name">{{item.abbreviation}}</div>
            </div>
          </div>
        </div>
      </div>
      <a-empty style="margin-top:40px;" v-else/>
    </div>
    <div class="content" style="margin-top: 50px;height: 100px;" v-else>
      <a-empty
        :image="hiddenImg"
        :image-style="{height: '30px'}">
        <span slot="description" style="color:#bbbaba;">
          <!-- 主办方隐藏了参赛数据 -->
        </span>
      </a-empty>
    </div>
    <!-- 队员弹窗 -->
    <a-modal v-model="visible" :title="teamName" :footer="null">
      <div class="player-model">
        <div class="team">
          <div class="team-name">管理人员</div>
          <div class="team-list">
            <div class="player-list">
              <template v-for="(item,key ,index) in dataDetail.leader">
                <div class="player-item" v-for="(value, k,j) in item" :key="j" >
                  <div  class="player-box">
                      <img :src="value.image">
                      <div class="name">{{value.name}}</div>
                      <div class="position">{{ matchFun.getLeaderName(key)}}</div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="team">
          <div class="team-name">参赛运动员</div>
          <div v-for="(combat, index) in dataDetail.combats" :key="'combat_' + index" class="team-list">
            <div class="combat-name">{{ combat.combatName }}<span>{{ combat.players.length }}人</span></div>
            <div class="player-list">
              <div class="player-item" v-for="(player, playerIndex) in combat.players" :key="'player_' + playerIndex">
                <div class="player-box">
                  <img :src="player.head" alt="">
                  <div class="name">{{ player.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name:'EventTeamSwiper',
  components: {
  },
  data () {
    return {
      matchFun: matchFun,
      hiddenImg: require('@comm/assets/hidden.png'),
      bannerList:[
        {
          id:1,
          name:'参赛代表队1',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
          playersList:[
            {
              id:1,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:2,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:3,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:4,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:5,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:6,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:7,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:7,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
            {
              id:7,
              name:'运动员1',
              image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500',
              position:'领队'
            },
          ]
        },
        {
          id:2,
          name:'参赛代表队2',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:3,
          name:'参赛代表队3',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:4,
          name:'参赛代表队4',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:5,
          name:'参赛代表队5',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:6,
          name:'参赛代表队6',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:7,
          name:'参赛代表队7',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:7,
          name:'参赛代表队7',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:7,
          name:'参赛代表队7',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
        {
          id:7,
          name:'参赛代表队7',
          image:'https://img1.baidu.com/it/u=3151123087,1494659345&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=500'
        },
      ],
      visible:false,
      teamName:'默认队名',
      currentPlayers:[],
      moveIndex:0,
      moveStyle:{
        transform:0
      },
      hidden: true,
      matchId: this.$route.query.matchId || 1,
      programId: this.$route.query.programId || 1,
      dataDetail: {combats: [], leader: null}
    }
  },
  mounted () {
    this.findData()
  },
  methods: {
    showPlayer (item) {
      this.visible = true
      this.teamName = item.name
      this.agencyJoinSimpleData(item)
      if(item.playersList){
        this.currentPlayers=item.playersList
      }
    },
    findData () {
      this.$api.match.queryJoinAgencyData({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.hidden = false
          this.bannerList = res.data
        } else if (res.status === 1102002) {
          this.hidden = true
        } else {
          this.hidden = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    agencyJoinSimpleData (item) {
      this.$api.match.agencyJoinSimpleData({matchId: this.matchId, agencyId: item.joinerId, type: item.joinerType}).then(res => {
        if (res.status === 0) {
          this.dataDetail = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    arrleft (){
      if(this.moveIndex>0){
        this.moveIndex--
        this.moveStyle.transform='translateX('+(-this.moveIndex*150)+'px)'
      }
    },
    arrright (){
      if(this.moveIndex<this.bannerList.length-7){
        this.moveIndex++
        this.moveStyle.transform='translateX('+(-this.moveIndex*150)+'px)'
      }
      if(this.moveIndex==this.bannerList.length-7){
        this.moveIndex++
        this.moveStyle.transform='translateX('+(-this.moveIndex*150+100)+'px)'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .row-bg{
    background-color: #efefef;
}
  // 对战弹窗
 /deep/ .ant-modal {
  width: 1200px !important;
}
 /deep/ .ant-modal-content {
  border-radius: 10px !important;
  min-height: 300px;
  height: 700px !important;  

}
 /deep/ .ant-modal-header {
  border-radius: 10px 10px 0 0 !important;
}
.et-banner{
  width: 1200px;
  margin: 0 auto;
  height: 260px;
  margin-top: 30px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
  border-radius: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;

  .title{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    line-height: 60px;
    height: 60px;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(238, 238, 238);
    .name{
      color: #000000;
      font-size: 18px;
      font-weight: bold;
    }
    .total{
      font-size: 14px;
      color: #999999;
    }
  }
  .banner-list{
    width: 1200px;
    height: 190px;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    .arr-right{
      position: absolute;
      right: 20px;
      top:50%;
      transform: translateY(-50%);
      cursor: pointer;
       z-index: 999;
    }
    .arr-right:hover{
      opacity: 0.8;
    }
    .arr-left{
      position: absolute;
      left: 20px;
      top:50%;
      transform: translateY(-50%); 
      cursor: pointer;
      z-index: 999;
    }
    .arr-left:hover{
      opacity: 0.8;
    }
    .banner-item{
      width: 1030px;
      margin: 0 auto;
      overflow: hidden;
      height: 100%;
      .banner-full{
        height: 100%;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        align-items: center;
        .banner-box{
          width: 120px;
          height: 100%;
          margin-right: 30px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          padding-top: 20px;
          align-items: center;
          text-align: center;
          cursor: pointer;
          img{
            width: 100px;
            height: 100px;
            margin-bottom: 10px;
          }
          .name{
            color: #000000;
            font-size: 14px;
            // margin-top: 20px;
          }
        }
      }
      
    }
  }
}
.player-model{
  width: 100%;
  height: 600px;
  overflow: auto;
  overflow-x: hidden;
  .team{
    color: #000000;
    width: 100%;

    .team-name{
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .team-list{
      .combat-name{
        margin-bottom: 10px;
      }
      .player-list{
        width: 100%;
        // height: 120px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        box-sizing: border-box;
        margin-bottom: 20px;
        .player-item{
          width: 82px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          
          .player-box{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img{
              width: 70px;
              height: 70px;
              border-radius: 8px;
            }
            .name{
              font-size: 14px;
              font-weight: bold;
              margin-top: 5px;
            }
            .position{
              font-size: 14px;
            }
            
          }
        }
        .nomargin{
          margin-right: 0;
        }
        .player-item:last-child{
          margin-right: auto;
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/comm/components/match/components/EventTeamSwiper.vue